import React from "react";
import styled from "styled-components";

const FooterLinkItemWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  margin: 0 25px;
`;

function FooterLinkItem({ children, href }: IFooterLinkItem) {
  return (
    <FooterLinkItemWrapper>
      <a
        href={href}
        style={{
          color: "black",
          opacity: 0.6,
          fontSize: "14px",
        }}
      >
        {children}
      </a>
    </FooterLinkItemWrapper>
  );
}

export interface IFooterLinkItem {
  children: React.ReactChild;
  href: string;
}

export default FooterLinkItem;
